import Vue from 'vue';
import VueTailwind from 'vue-tailwind';

import settings from './settings';

Vue.use(VueTailwind, settings);